export const verifications = (api) => ({
  searchForCompanies(country, companyNumber, companyName, forType, forId, success, fail, authToken) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/verifications/companies/search?country=${country}&companyNumber=${companyNumber}&companyName=${encodeURIComponent(companyName)}&forType=${forType}&forId=${forId}${authToken ? `&authToken=${authToken}` : ""}`,
      null,
      success,
      fail,
    )
  },
  createReport(data, success, fail, authToken) {
    const { id, forType, forId, templatedFieldId } = data
    api.maybeAuthenticatedRequest(
      "POST",
      "/verifications/companies/reports",
      {
        id,
        forType,
        forId,
        authToken: authToken || null,
        templatedFieldId: templatedFieldId || null,
      },
      success,
      fail,
    )
  },
  getReports(success, fail) {
    api.authenticatedRequest("GET", "/verifications/companies/reports", null, success, fail)
  },
})
